import { Lead } from '../types/Lead';
import { apiService } from './apiService';


const LeadService = {
    createLead: async (data: Lead, signal?: AbortSignal) => {
        try {
            const response = await apiService.post('/leads/', data, {
                signal, 
            });

            return response;

        } catch (error: any) {
            console.error("Error in createLead:", error);

            return {
                message: error.response?.data?.code || error.message || "An error occurred while adding the lead.",
                error,
            };
        }
    },
    
    getAllLeads: async (signal?: AbortSignal) => {
        try {
            const response = await apiService.get('/leads/', {
                signal, 
            });
    
            return response; // Make sure response is correctly returned
        } catch (error: any) {

            if (error.response === 401) {
                throw new Error("Unauthorized: Please log in again.");
            }
    
            console.error("Error in getAllLeads:", error);

            return {
                message: error.response?.data?.code || error.message || "An error occurred while getting the leads.",
                error,
            };
        }
    },

    updateLead: async (leadId: string, updateData: any, signal?: AbortSignal) => {
        try {
            const response = await apiService.patch(`/leads/${leadId}`, updateData, {
                signal, 
            });

            return response;
        } catch (error: any) {
            console.error("Error in updateLead:", error);

            return {
                message: error.response?.data?.code || error.message || "An error occurred while updating the lead.",
                error,
            };
        }
    },

    deleteLead: async (leadId: string, signal?: AbortSignal) => {
        try {            
            const response = await apiService.delete(`/leads/${leadId}`, {
                signal, 
            });

            return response;
        } catch (error: any) {
            console.error("Error in deleteLead:", error);

            return {
                message: error.response?.data?.code || error.message || "An error occurred while deleting the lead.",
                error,
            };
        }
    },

};

export default LeadService;
